<template>
  <div class="card mb-25 border-0 rounded-0 bg-white monthly-revenue-box radius-7 heigth-other-cards-dashboard">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-time-card">
      <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard">Tempo total de gravação</span>
      <h4 class="fw-black mb-12 lh-1 font-size-32">{{ convertTime(getDashboardDayCards.total_time) }}</h4>
    </div>
  </div>
</template> 

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "DashboardDayTime",
  computed:{
    ...mapGetters([
      'getDashboardDayCards'
    ])
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
});
</script>